import { render, staticRenderFns } from "./CommandsTable.vue?vue&type=template&id=7298ef86&scoped=true&"
import script from "./CommandsTable.vue?vue&type=script&lang=ts&"
export * from "./CommandsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7298ef86",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7298ef86')) {
      api.createRecord('7298ef86', component.options)
    } else {
      api.reload('7298ef86', component.options)
    }
    module.hot.accept("./CommandsTable.vue?vue&type=template&id=7298ef86&scoped=true&", function () {
      api.rerender('7298ef86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/commands/CommandsTable.vue"
export default component.exports